export default "__VITE_ASSET__sTC5JqSI__"